// extracted by mini-css-extract-plugin
module.exports = {"root":"HoveringToolbar_root__1eJ2J","button":"HoveringToolbar_button__1t8KY"};